// Constants related to InscriptionEvents and InscriptionComments

export const ORG_CHART_FINANCE_ID = 'orgChartFinanceId';
export const GESTIONNAIRE_ID = 'gestionnaireId';
export const BUDGET_LINE_SOFTWARE_ID = 'budgetLineSoftwareId';
export const ENRICHED_OPERATION_SOFTWARE_ID = 'enrichedOperationSoftwareId';
export const CHAPTER_ID = 'chapterId';
export const NATURE_ID = 'natureId';
export const INSCRIPTION_ORIGIN = 'inscription';

export const EXTRACTOR_USER_PREFIX = 'extractor_';
